import { defineComponent as _defineComponent } from 'vue'
import { computed, getCurrentInstance, onMounted, ref, watch } from 'vue';
import ProductCategoriesRepository from '@/repositories/ProductCategoriesRepository';
import { EventBus } from '@/helpers/EventBusHelper';
import { EventBusEvents } from '@/enums/global/EventBusEvents';
import ProductCategory from '@/models/ProductCategory';
import { LoadingOverlayHelper } from '@/helpers/LoadingOverlayHelper';
import CalculatorProductSelector from '@/modules/Calculator/components/CalculatorProductSelector.vue';
import { RadioButtonGroupOptions } from '@/interfaces/components/RadioButtonGroupOptions';
import { generateProductCategoryOptions } from '@/helpers/Products/ProductHelper';
import { Tabs } from 'ant-design-vue';
import ProductAndMaterialSearch from '@/components/views/NewProjectView/Offer/ProductAndMaterialSearch.vue';
import ColorModule from '@/modules/ColorModule/views/ColorModule.vue';

interface Props {
    isLoading?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CalculatorMainSection',
  props: {
    isLoading: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { isLoading: boolean };



const { proxy } = getCurrentInstance()!;
const TabPane = Tabs.TabPane;
const hasUnsavedData = ref(false);
const loadingOverlay = new LoadingOverlayHelper(proxy, {});
const selectedProductCategory = ref('');

const productCategories = computed(() => ProductCategoriesRepository.getAll());
const isSeletedCategoryMaterials = computed(() => {
    if (selectedProductCategory.value == null) {
        return false;
    }

    const categoryById = ProductCategoriesRepository.getById(selectedProductCategory.value);

    if (categoryById == null) {
        return false;
    }

    return categoryById.code === 'MATERIALS';
});
const productCategoryOptions = computed<RadioButtonGroupOptions[]>(() =>
    generateProductCategoryOptions(productCategories.value, true),
);

const updateUnsavedDataState = ({ state }: { state: boolean }) => {
    hasUnsavedData.value = state;
};

watch(
    productCategoryOptions,
    (updatedProductCategoryOptions) => {
        if (updatedProductCategoryOptions.length > 0) {
            selectedProductCategory.value = updatedProductCategoryOptions[0].value;
        }
    },
    { deep: true },
);

onMounted(async () => {
    loadingOverlay.start();

    EventBus.$on(EventBusEvents.changesInDataMade, updateUnsavedDataState);
    try {
        await ProductCategory.getAll();
        loadingOverlay.stop();
    } catch (e) {
        return;
    }
});

return { __sfc: true,props, proxy, TabPane, hasUnsavedData, loadingOverlay, selectedProductCategory, productCategories, isSeletedCategoryMaterials, productCategoryOptions, updateUnsavedDataState, CalculatorProductSelector, Tabs, ProductAndMaterialSearch, ColorModule }
}

})